import { Text } from '@chakra-ui/react'

interface NoCheckPointViewIProps {
  title: string
}

export const NoCheckPointView = ({ title }: NoCheckPointViewIProps) => {
  return (
    <Text
      color='#44546F'
      fontSize='13px'
      fontWeight={500}
      lineHeight='16px'
      mb='10px'
    >
      {title}
    </Text>
  )
}
